import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IWizardStepRendererProps, StackPanel, TagValue, Typography } from '@agilepoint/wat-react-ux';
import { Localize, useTranslate } from '@agilepoint/wat-react';
import { StyledEmailInputControl } from 'modules/shared/styled-components';
import { IMobileApplicationDetails } from 'modules/create-new-app/queries';
import { MobileAppHelpLink, StyledStackPanel } from 'common';
import { WizardNavigationActions } from '../footers';


interface IBuildAppProps extends IWizardStepRendererProps {
    notificationList: string[];
    onSaveBuildDetails: (formData: { emailList: string, saveAsDraft?: boolean }) => Promise<{
        UpdateMobileAppResult: IMobileApplicationDetails;
    }>;
}

export const BuildApp = React.memo((props: IBuildAppProps) => {
    const { stepId, notificationList, onSaveBuildDetails } = props;
    const [tagInputItems, setTagInputItems] = React.useState<TagValue[]>(notificationList);
    const navigate = useNavigate();
    const translate = useTranslate();

    const onTagInputChange = React.useCallback((values: TagValue[]) => {
        setTagInputItems(values);
    }, []);

    const handleBuildDetails = React.useCallback((saveAsDraft?: boolean) => onSaveBuildDetails({ emailList: JSON.stringify(tagInputItems.join(',')), saveAsDraft: saveAsDraft }).then((res) => {
        const { AppBaseId, AppId } = res.UpdateMobileAppResult;
        navigate({ pathname: `/my-apps/app-details/${AppId}/${AppBaseId}`, search: saveAsDraft ? '' : 'isSuccess=true' });
        return true;
    }).catch(() => false), [navigate, onSaveBuildDetails, tagInputItems]);

    const onSubmit = React.useCallback(() => handleBuildDetails(), [handleBuildDetails]);

    const onSaveAsDraft = React.useCallback(() => handleBuildDetails(true), [handleBuildDetails]);

    return (
        <>
            <MobileAppHelpLink id="buildApp" />
            <StyledStackPanel margin='30px 0px 0px 0px' orientation='vertical' gap='30' alignment="center">
                <StackPanel gap="10" orientation='vertical' alignment="center" width='100%'>
                    <Typography.H2 title={translate('modules.createNewApp.steps.buildApp.emailAddressInputHeader')}><Localize translate='modules.createNewApp.steps.buildApp.emailAddressInputHeader' /></Typography.H2>
                    <Typography.Medium title={translate('modules.createNewApp.steps.buildApp.buildAppSubTitle')}><Localize translate='modules.createNewApp.steps.buildApp.buildAppSubTitle' /></Typography.Medium>
                </StackPanel>
                <StyledEmailInputControl
                    enableClearList
                    tagInputItems={tagInputItems}
                    onChange={onTagInputChange} />
            </StyledStackPanel>
            <WizardNavigationActions
                stepId={stepId}
                hook={onSubmit}
                secondaryPositiveActionType={translate('modules.createNewApp.steps.buildApp.saveAsDraftText')}
                secondaryAction={onSaveAsDraft} />
        </>
    );
});
